import React, { useEffect, useState } from "react";
import workingImage from "./../../assets/working.png";
import circle from "./../../assets/green_circle.svg";

function Footer() {
  const handleDemoClick = () => {
    window.open("https://www.healthasyst.com/checkinasyst/schedule-a-demo/");
  };

  return (
    <>
      <div
        className="flex  h-[220px]  mt-[80px] justify-center items-center"
        style={{
          background: "linear-gradient(269.35deg, #72BA51 28.26%, #147B6D 96.08%)",
        }}
      >
        <div className="flex flex-col  h-full gap-10 justify-center footer-text">
          <p className="text-white  font-semibold text-2xl mx-4 text-wrap  ">
            Want to know more about how CheckinAsyst can bring value for your practice?
          </p>

          <button
            className="btn-demo  h-[50px] bg-[#71B254] rounded-lg text-white font-semibold text-xl flex justify-center items-center"
            style={{borderColor: "#FFFFFF"}}
            onClick={handleDemoClick}
            id="schedule-a-demo"
          >
            Schedule a Demo
          </button>
        </div>
      </div>
      {/* <div className="py-2 mb-2 flex justify-center items-center">
        <p>© 2024 HealthAsyst®. All rights reserved.</p>
      </div> */}
    </>
  );
}

export default Footer;
